module.exports = __webpack_public_path__ + "img/impactoE2.b75a93a2.png";